import "./Modal.css";
import Play from "../../pages/Play";

const Modal= ({changeImage})=> {

        return (
          
            <div className="modalContainer">
              <div className="titleCloseBtn">
              </div>
              <div className="title">
                <h1>Felicitaciones! encontrastes todos los objetos</h1>
              </div>
              <div className="body">
                <p>Darle continuar para seguir</p>              
              </div>
              <div className="footer">
                <button onClick={changeImage}>Continuar</button>
              </div>
            </div>
         
        );
    
  }

export default Modal;
